<div class="dialog-backdrop" (click)="onBackdropClick($event)">
  <main class="alert-dialog" [ngClass]="type" appCloseOnEscape (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="onCancel()" [attr.aria-label]="'dialog.closeAria' | transloco">&times;</button>

    <div class="header">
      <span class="icon" [attr.aria-hidden]="true" role="img">
        <ng-container [ngSwitch]="type">
          <!-- Успех -->
          <svg *ngSwitchCase="'success'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <!-- Ошибка -->
          <svg *ngSwitchCase="'error'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 7v6M12 16.5h.01" />
          </svg>
          <!-- Внимание -->
          <svg *ngSwitchCase="'warning'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            <path d="M12 9v4M12 17h.01" />
          </svg>
          <!-- Информация -->
          <svg *ngSwitchDefault viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4M12 8h.01" />
          </svg>
        </ng-container>
      </span>
      <h4 class="title" *ngIf="data.title">{{ data.title }}</h4>
    </div>
    <div class="content" *ngIf="message">
      <p class="message">{{ message }}</p>
    </div>
    <div class="actions">
      <button *ngIf="data.showCancelButton" class="btn ghost" (click)="onCancel()">
        {{ data.cancelButtonText || ('dialog.no' | transloco) }}
      </button>
      <button class="btn primary" (click)="onConfirm()">
        {{ data.confirmButtonText || ('dialog.ok' | transloco) }}
      </button>
    </div>
  </main>
</div>
